// import React, { useState, useEffect, useRef } from "react";
// import "./service.css";
// import Navbar from "../components/Navbar";
// import Footer from "./main/footer";
// import api from "../services/httpService";
// import { Calendar } from "lucide-react";
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { EffectCoverflow, Navigation, Autoplay} from 'swiper/modules';

// // Import Swiper styles
// import 'swiper/css';
// import 'swiper/css/effect-coverflow';
// import 'swiper/css/navigation';

// const Servicepage = () => {
//   const [hero, setHero] = useState(null);
//   const [services, setServices] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [selectedService, setSelectedService] = useState(null);
//   const [showDetailModal, setShowDetailModal] = useState(false);
//   const [isPaused, setIsPaused] = useState(false);
//   const [themeColors, setThemeColors] = useState({
//     color1: "",
//     color2: ""
//   });
//   const tickerRef = useRef(null);
//   const swiperRef = useRef(null);

//   useEffect(() => {
//     fetchHeroAndServices();
//     fetchThemeColors();
//   }, []);

//   // Auto-scroll ticker for latest updates
//   useEffect(() => {
//     if (!tickerRef.current || services.length === 0 || isPaused) return;

//     const ticker = tickerRef.current;
//     const content = ticker.firstChild;
//     let animationId;
//     let position = 0;
//     const speed = 0.5;

//     const animate = () => {
//       if (isPaused) return;
//       position -= speed;
//       if (Math.abs(position) >= content.scrollHeight / 2) {
//         position = 0;
//       }
//       content.style.transform = `translateY(${position}px)`;
//       animationId = requestAnimationFrame(animate);
//     };

//     animationId = requestAnimationFrame(animate);

//     return () => {
//       cancelAnimationFrame(animationId);
//     };
//   }, [services, isPaused]);

//   const fetchThemeColors = async () => {
//     try {
//       const res = await api.get("/sentinix/dashboardsettings");
//       if (res.data.success && res.data.data) {
//         const allData = Array.isArray(res.data.data)
//           ? res.data.data
//           : [res.data.data];
        
//         const latest = allData.sort((a, b) => b.id - a.id)[0];
        
//         if (latest) {
//           const color1 = latest.color1 || "";
//           const color2 = latest.color2 || "";
          
//           setThemeColors({ color1, color2 });
          
//           document.documentElement.style.setProperty("--theme-color1", color1);
//           document.documentElement.style.setProperty("--theme-color2", color2);
//         }
//       }
//     } catch (err) {
//       console.error("Error fetching theme colors:", err);
//       document.documentElement.style.setProperty("--theme-color1", "");
//       document.documentElement.style.setProperty("--theme-color2", "");
//     }
//   };

//   const fetchHeroAndServices = async () => {
//     try {
//       const res = await api.get("/sentinix/services");

//       if (res.data.success) {
//         const data = res.data.data || [];

//         // Hero data
//         const heroData = data.find(
//           (item) => item.type === "hero" && !item.isDeleted
//         );
//         setHero(heroData || null);

//         // Services data
//         const serviceList = data.filter(
//           (item) => item.type === "service" && !item.isDeleted
//         );
//         setServices(serviceList);
//       }
//     } catch (err) {
//       console.error("Error fetching services", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDate = (dateString) => {
//     if (!dateString) return "N/A";
//     return new Date(dateString).toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric'
//     });
//   };

//   const handleServiceClick = (service) => {
//     setSelectedService(service);
//     setShowDetailModal(true);
//     if (swiperRef.current) {
//       swiperRef.current.autoplay.stop();
//     }
//   };

//   const closeModal = () => {
//     setShowDetailModal(false);
//     setSelectedService(null);
//     if (swiperRef.current) {
//       swiperRef.current.autoplay.start();
//     }
//   };

//   // Loading Skeleton
//   if (loading) {
//     return (
//       <>
//         <Navbar />
//         <div className="loading-container">
//           <div className="loading-hero"></div>
//           <div className="loading-content">
//             <div className="loading-title"></div>
//             <div className="loading-cards">
//               {[1, 2, 3].map((i) => (
//                 <div key={i} className="loading-card"></div>
//               ))}
//             </div>
//           </div>
//         </div>
//         <Footer />
//       </>
//     );
//   }

//   return (
//     <>
//       <Navbar />

//       <div className="service-container">
//         {/* ================= HERO BANNER ================= */}
//         <div className="service-hero">
//           {hero?.ImageKey ? (
//             <img
//               src={hero.ImageKey}
//               alt="Services Banner"
//               className="service-hero-img"
//             />
//           ) : (
//             <div className="service-hero-placeholder" />
//           )}

//           <div className="service-hero-overlay">
//             <h1 className="service-hero-title">
//               {hero?.name || "Our Services"}
//             </h1>
//             <p className="service-hero-description">
//               {hero?.description || "Discover our premium services"}
//             </p>
//           </div>
//         </div>

//         {/* ================= MAIN CONTENT ================= */}
//         <div className="service-main">
//           <div className="service-grid">
//             {/* Left Column - Services Slider */}
//             <div className="service-left">
//               <div className="service-slider-container">
//                 <div className="service-section">
//                   <div className="service-section-header">
//                     <h2 className="service-section-title">
//                       Our Services
//                     </h2>
//                     <div className="service-section-divider" />
//                   </div>

//                   {services.length === 0 ? (
//                     <p className="service-empty">No services available</p>
//                   ) : (
//                     <div className="service-swiper-wrapper">
//                       <Swiper
//                         onSwiper={(swiper) => {
//                           swiperRef.current = swiper;
//                         }}
//                         effect="coverflow"
//                         grabCursor={true}
//                         centeredSlides={true}
//                         slidesPerView="auto"
//                         loop={true}
//                         speed={800}
//                         autoplay={{
//                           delay: 2000,             
//                           disableOnInteraction: false,
//                           pauseOnMouseEnter: false, 
//                         }}
//                         coverflowEffect={{
//                           rotate: 0,
//                           stretch: 10,
//                           depth: 200,
//                           modifier: 1,
//                           slideShadows: false,
//                         }}
//                         modules={[EffectCoverflow, Autoplay, Navigation]}
//                         className="service-swiper"
//                       >
//                         {services.length <= 4 
//                           ? [...services, ...services, ...services, ...services].map((service, index) => (
//                               <SwiperSlide key={`${service.id}-${index}`} className="service-slide">
//                                 <div
//                                   onClick={() => handleServiceClick(service)}
//                                   className="service-card"
//                                 >
//                                   <div className="service-card-inner">
//                                     <div className="service-card-index">
//                                       0{(index % services.length) + 1}
//                                     </div>

//                                     <div className="service-card-image-container">
//                                       <img
//                                         src={service.ImageKey || "/no-image.png"}
//                                         alt={service.name}
//                                         className="service-card-image"
//                                         onError={(e) => (e.target.src = "/no-image.png")}
//                                       />
//                                       <div className="service-card-overlay" />
//                                     </div>

//                                     <div className="service-card-content">
//                                       <h3 className="service-card-title">
//                                         {service.name}
//                                       </h3>
//                                       <p className="service-card-description">
//                                         {service.description?.substring(0, 100)}...
//                                       </p>
//                                       <button 
//                                         className="service-card-button"
//                                         onClick={(e) => {
//                                           e.stopPropagation();
//                                           handleServiceClick(service);
//                                         }}
//                                       >
//                                         Read More
//                                       </button>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </SwiperSlide>
//                             ))
//                           : services.map((service, index) => (
//                               <SwiperSlide key={service.id} className="service-slide">
//                                 <div
//                                   onClick={() => handleServiceClick(service)}
//                                   className="service-card"
//                                 >
//                                   <div className="service-card-inner">
//                                     <div className="service-card-index">
//                                       0{index + 1}
//                                     </div>

//                                     <div className="service-card-image-container">
//                                       <img
//                                         src={service.ImageKey || "/no-image.png"}
//                                         alt={service.name}
//                                         className="service-card-image"
//                                         onError={(e) => (e.target.src = "/no-image.png")}
//                                       />
//                                       <div className="service-card-overlay" />
//                                     </div>

//                                     <div className="service-card-content">
//                                       <h3 className="service-card-title">
//                                         {service.name}
//                                       </h3>
//                                       <p className="service-card-description">
//                                         {service.description?.substring(0, 100)}...
//                                       </p>
//                                       <button 
//                                         className="service-card-button"
//                                         onClick={(e) => {
//                                           e.stopPropagation();
//                                           handleServiceClick(service);
//                                         }}
//                                       >
//                                         Read More
//                                       </button>
//                                     </div>
//                                   </div>
//                                 </div>
//                               </SwiperSlide>
//                             ))
//                         }
//                       </Swiper>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* ================= DETAIL MODAL ================= */}
//         {showDetailModal && selectedService && (
//           <div className="service-modal-overlay" onClick={closeModal}>
//             <div 
//               className="service-modal-content"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <button className="service-modal-close" onClick={closeModal}>
//                 ×
//               </button>

//               <div className="service-modal-grid">
//                 <div className="service-modal-image-container">
//                   <img
//                     src={selectedService.ImageKey || "/no-image.png"}
//                     alt={selectedService.name}
//                     className="service-modal-image"
//                   />
//                   <div className="service-modal-date">
//                     <Calendar size={16} />
//                     <span>{formatDate(selectedService.createdAt)}</span>
//                   </div>
//                 </div>

//                 <div className="service-modal-details">
//                   <h2 className="service-modal-title">
//                     {selectedService.name}
//                   </h2>
                  
//                   {selectedService.title && (
//                     <p className="service-modal-subtitle">
//                       {selectedService.title}
//                     </p>
//                   )}

//                   <div className="service-modal-description">
//                     {selectedService.description?.split('\n').map((para, idx) => (
//                       <p key={idx}>{para}</p>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       <Footer />
//     </>
//   );
// };

// export default Servicepage;

import React, { useState, useEffect, useRef } from "react";
import "./service.css";
import Navbar from "../components/Navbar";
import Footer from "./main/footer";
import api from "../services/httpService";
import { Calendar, X } from "lucide-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-coverflow";

const Servicepage = () => {
  const [hero, setHero]                   = useState(null);
  const [services, setServices]           = useState([]);
  const [loading, setLoading]             = useState(true);
  const [selectedService, setSelectedService] = useState(null);
  const [showModal, setShowModal]         = useState(false);
  const swiperRef = useRef(null);

  useEffect(() => { fetchAll(); }, []);

  const fetchAll = async () => {
    try {
      // Theme colors
      const themeRes = await api.get("/sentinix/dashboardsettings");
      if (themeRes.data.success && themeRes.data.data) {
        const allData = Array.isArray(themeRes.data.data)
          ? themeRes.data.data : [themeRes.data.data];
        const latest = allData.sort((a, b) => b.id - a.id)[0];
        if (latest?.color1) document.documentElement.style.setProperty("--theme-color1", latest.color1);
        if (latest?.color2) document.documentElement.style.setProperty("--theme-color2", latest.color2);
      }
      // Services
      const res = await api.get("/sentinix/services");
      if (res.data.success) {
        const data = res.data.data || [];
        setHero(data.find(i => i.type === "hero" && !i.isDeleted) || null);
        setServices(data.filter(i => i.type === "service" && !i.isDeleted));
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (d) => {
    if (!d) return "N/A";
    return new Date(d).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
  };

  const openModal = (service) => {
    setSelectedService(service);
    setShowModal(true);
    swiperRef.current?.autoplay.stop();
  };

  const closeModal = () => {
    setShowModal(false);
    setSelectedService(null);
    swiperRef.current?.autoplay.start();
  };

  // Duplicate for infinite smooth loop (minimum 8 slides needed)
  const getSlides = () => {
    if (services.length === 0) return [];
    let slides = [...services];
    while (slides.length < 8) slides = [...slides, ...services];
    return slides;
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <div className="svc-loading">
          <div className="svc-load-hero" />
          <div className="svc-load-body">
            <div className="svc-load-title" />
            <div className="svc-load-cards">
              {[1,2,3].map(i => <div key={i} className="svc-load-card" />)}
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const slides = getSlides();

  return (
    <>
      <Navbar />
      <div className="svc-page">

        {/* ─────────── HERO ─────────── */}
        <div className="svc-hero">
          {hero?.ImageKey
            ? <img src={hero.ImageKey} alt="hero" className="svc-hero-img" />
            : <div className="svc-hero-bg" />
          }
          {/* <div className="svc-hero-overlay">
            <h1 className="svc-hero-title">{hero?.name || "Our Services"}</h1>
            <p className="svc-hero-desc">{hero?.description || "Discover our premium services"}</p>
          </div> */}
        </div>

        {/* ─────────── SECTION TITLE ─────────── */}
        <div className="svc-head">
          <h2 className="svc-head-title">Our Services</h2>
          <div className="svc-head-bar" />
          <p className="svc-head-sub">Click any card to explore details</p>
        </div>

        {/* ─────────── SWIPER ─────────── */}
        {services.length === 0 ? (
          <p className="svc-empty">No services available</p>
        ) : (
          <div className="svc-swiper-outer">
            <Swiper
              onSwiper={swiper => { swiperRef.current = swiper; }}
              effect="coverflow"
              grabCursor={true}
              centeredSlides={true}
              slidesPerView="auto"
              loop={true}
              speed={300}
              autoplay={{
                delay: 1700,
                disableOnInteraction: false,
                waitForTransition: false,
                pauseOnMouseEnter: false,
              }}
              coverflowEffect={{
                rotate: 0,
                stretch: 30,
                depth: 150,
                modifier: 1,
                slideShadows: false,
              }}
              modules={[EffectCoverflow, Autoplay]}
              className="svc-swiper"
            >
              {slides.map((service, index) => (
                <SwiperSlide key={`${service.id}-${index}`} className="svc-slide">
                  <div className="svc-card" onClick={() => openModal(service)}>
                    {/* Badge */}
                    <div className="svc-badge">
                      {String((index % services.length) + 1).padStart(2, "0")}
                    </div>

                    {/* Image */}
                    <div className="svc-img-wrap">
                      <img
                        src={service.ImageKey || "/no-image.png"}
                        alt={service.name}
                        className="svc-img"
                        onError={e => (e.target.src = "/no-image.png")}
                      />
                      <div className="svc-img-overlay" />
                    </div>

                    {/* Content */}
                    <div className="svc-card-body">
                      <h3 className="svc-card-title">{service.name}</h3>
                      <p className="svc-card-desc">
                        {service.description?.substring(0, 85)}...
                      </p>
                      <span className="svc-card-btn">Read More →</span>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        )}

        {/* ─────────── MODAL ─────────── */}
        {showModal && selectedService && (
          <div className="svc-modal-bg" onClick={closeModal}>
            <div className="svc-modal" onClick={e => e.stopPropagation()}>
              <button className="svc-modal-close" onClick={closeModal}>
                <X size={18} />
              </button>
              <div className="svc-modal-grid">
                {/* Image */}
                <div className="svc-modal-img-wrap">
                  <img
                    src={selectedService.ImageKey || "/no-image.png"}
                    alt={selectedService.name}
                    className="svc-modal-img"
                  />
                  <div className="svc-modal-date">
                    <Calendar size={13} />
                    <span>{formatDate(selectedService.createdAt)}</span>
                  </div>
                </div>
                {/* Details */}
                <div className="svc-modal-body">
                  <h2 className="svc-modal-title">{selectedService.name}</h2>
                  {selectedService.title && (
                    <p className="svc-modal-sub">{selectedService.title}</p>
                  )}
                  <div className="svc-modal-desc">
                    {selectedService.description?.split("\n").map((p, i) => (
                      <p key={i}>{p}</p>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <Footer />
    </>
  );
};

export default Servicepage;